import { render, staticRenderFns } from "./contrat-de-remplacement-create-dialog.vue?vue&type=template&id=45540f2f&scoped=true"
import script from "./contrat-de-remplacement-create-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./contrat-de-remplacement-create-dialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45540f2f",
  null
  
)

export default component.exports